<template>
  <div class="md-layout">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <h6 class="text-primary">Upcoming Departures</h6>
      </md-card-header>

      <md-card-content>
        <template v-if="departures.length">
          <router-link
            v-for="dep in departures"
            :key="dep.id"
            :to="{
              name: 'Departure Profile',
              params: { tour_id: dep.tour_id, departure_id: dep.id }
            }"
            tag="div"
            class="departure-item md-layout"
          >
            <div class="md-layout-item md-size-100 tour">
              <h6>{{ dep.tour }}</h6>
            </div>
            <div class="md-layout-item md-size-60 pax">
              {{ dep.start_date }}
            </div>
            <div class="md-layout-item md-size-40 pax text-right">
              {{ dep.num_passengers }} / {{ dep.max_group_size }}
            </div>
          </router-link>
        </template>
        <div v-else class="empty-state text-center">
          <p>There are no upcoming departures.</p>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import departureApi from "@/services/api/departure";

export default {
  name: "WidgetUpcomingDepartures",
  data() {
    return {
      departures: []
    };
  },

  computed: {},

  methods: {},

  created() {
    departureApi.getUpcomingDepartures().then(response => {
      this.departures = response.data.departures;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.tour h6 {
  margin: 0;
}
p {
  margin: 0;
}
.departure-item {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;
  cursor: pointer;
}
.actions {
  .action-button {
    width: 24px;
    min-width: 24px;
    height: 24px;
    margin: 0px;
  }
}
</style>
